module.exports = __webpack_public_path__ + "static/media/male_death.1cecc8ff.mp3";